import MediaInserterSelector from '@intercom/embercom-composer/components/media-inserter-twitter';
export default MediaInserterSelector;
